import { observer } from 'mobx-react';
import React, { FC } from 'react';
import { ListContainer } from 'src/components/Containers/ListContainer/ListContainer';
import { WidgetTable } from 'src/libs/ui-kit/widget-table/WidgetTable';
import { useStore } from 'src/modules/users/hooks/useStore';
import { UserContactsStoreContext } from '../../UserContacts.widget';
import { UserContactTableRow } from './UserContactTableRow';
import { UserContactTableSubHeader } from './UserContactTableSubHeader';

export const UserContactsTable: FC = observer(() => {
  const store = useStore(UserContactsStoreContext);

  return (
    <div className="px-5">
      <WidgetTable>
        <thead>
          <tr>
            <th className="border-0 text-tiny pt-0">Контакт</th>
            <th className="border-0 text-tiny pt-0">Верифицирован</th>
            <th className="border-0 text-tiny pt-0">Основной</th>
            <th className="border-0 text-tiny pt-0" title="Является ли контакт отозванным">
              Актуальный
            </th>
          </tr>
        </thead>
        <tbody>
          {store.getArePhonesVisible && (
            <>
              <UserContactTableSubHeader title="Телефон" />
              <ListContainer ItemComponent={UserContactTableRow} items={store.getPhones} />
            </>
          )}
          {store.getAreEmailsVisible && (
            <>
              <UserContactTableSubHeader title="E-Mail" />
              <ListContainer ItemComponent={UserContactTableRow} items={store.getEmails} />
            </>
          )}
        </tbody>
      </WidgetTable>
    </div>
  );
});
